
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { Button } from "@/components/ui/button";
import { LogOut } from "lucide-react";

interface SidebarFooterContentProps {
  onLogout: () => void;
}

export function SidebarFooterContent({ onLogout }: SidebarFooterContentProps) {
  return (
    <div className="p-4 space-y-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-2">
          <Avatar className="h-8 w-8">
            <AvatarFallback className="bg-primary text-primary-foreground">
              U
            </AvatarFallback>
          </Avatar>
          <div>
            <p className="text-sm font-medium">User</p>
          </div>
        </div>
        <Button
          variant="ghost"
          size="icon"
          title="Logout"
          onClick={onLogout}
        >
          <LogOut className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
}
